/**
 * Display formatting for risk-taxonomy labels.
 *
 * The datasets store taxonomy labels as "1.1 Unfair discrimination…" /
 * "4 Malicious actors" (number, space, name — no separator), and the
 * Incident Tracker used to render them verbatim, while the Governance Map
 * components build their labels as `${id} - ${name}`. One site, two styles.
 * This helper converts the stored form to the dashed form at the display
 * boundary, so every legend, tooltip, dropdown, chip and table cell reads
 * "1.1 - Name" — matching the Governance side.
 *
 * Display-only: filter VALUES sent back to the API must stay the raw stored
 * strings, so never format a value that will be used for matching.
 */
export function formatTaxonomyLabel(label: string): string {
  // A leading dotted-or-bare number followed by whitespace and a name gains
  // " - "; already-dashed labels and non-taxonomy strings (years, "None
  // identified", severity values) pass through untouched.
  return label.replace(/^(\d+(?:\.\d+)?)\s+(?!-\s)/, '$1 - ');
}
